import { getOrderDisplayActivityAt } from '../../../../utils/order/orderDisplayTime';

/** 待办列表「最近更新」列：统一使用 uiHints.activityAt */
export const buildPendingActivityAtColumn = (formatDateTime) => ({
	id: 'activityAt',
	accessorFn: (row) => {
		const at = getOrderDisplayActivityAt(row);
		if (!at) return 0;
		const time = new Date(at).getTime();
		return Number.isNaN(time) ? 0 : time;
	},
	header: '最近更新',
	meta: {
		headerProps: {
			className: 'text-end text-900',
		},
		cellProps: {
			className: 'text-end',
		},
	},
	cell: ({ row: { original } }) => {
		const activityAt = getOrderDisplayActivityAt(original);
		return <span className='fs-11'>{activityAt ? formatDateTime(activityAt) : '-'}</span>;
	},
});

export const PENDING_ACTIVITY_AT_SORT = [{ id: 'activityAt', desc: true }];
